import { ComplianceCardWrapperProps } from '../types/ComplianceCard.types';
import {
  ComplianceCardNew,
} from './ComplianceCardNew';
import { ComplianceCard } from './ComplianceCardOld';
import { ComplianceCardWithInnerAction} from './ComplianceCardWithInnerAction';

const ComplianceCardWrapper = (wrapperProps: ComplianceCardWrapperProps) => {
  const {ff_ren1520_compliancewelcome_newdesign, v2, ...props} = wrapperProps;

  if(!v2) {
    return <ComplianceCard {...props} />;
  }

  return ff_ren1520_compliancewelcome_newdesign ? (
    <ComplianceCardWithInnerAction {...props} />
  ) : (
    <ComplianceCardNew {...props}/>
  );
};

export { ComplianceCardWrapper };
